module.exports = __webpack_public_path__ + "img/about.be8eb5a6.png";